import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/centro-distribuicao',
  name: 'centro-distribuicao',
  component: Index,
  children: [
    { path: 'listar', name: 'centro-distribuicao-listar', component: Listar },
    { path: 'novo', name: 'centro-distribuicao-novo', component: Novo },
    { path: ':id', name: 'centro-distribuicao-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'centro-distribuicao-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/centro-distribuicao/routes.js